import { useSnackbar } from 'notistack';
import React, { ChangeEvent, useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useEmployeeLoginData } from '~/data/employee';

import { putChangeAccountStatus } from './data';

export type useChangeAccountStatusOutput = {
  onSubmit: () => void;
  status: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

type PropsType = {
  onSubmitSuccess?: () => void;
};

export const useChangeAccountStatus = (
  props: PropsType,
): useChangeAccountStatusOutput => {
  const { onSubmitSuccess } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [status, setStatus] = useState<string>('');
  const { t } = useTranslation();
  const {
    employeeAdminLoginData: employeeLoginData,
    loginDataLoading: isLoading,
    loginDataFailedLoading: failedToLoad,
  } = useEmployeeLoginData();

  useEffect(() => {
    if (!isLoading && !failedToLoad) {
      setStatus(employeeLoginData.fLoginStatus);
    }
  }, [employeeLoginData.fLoginStatus, failedToLoad, isLoading]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setStatus(e.target.value);
  };

  const handleFormSubmit = () => {
    (async () => {
      try {
        const response = await putChangeAccountStatus(
          employeeLoginData.fLoginUsername,
          status,
        );
        if (response) {
          if (!!onSubmitSuccess) {
            onSubmitSuccess();
          }
          enqueueSnackbar(t('laChangeAccountStatusOK'), {
            variant: 'success',
          });
        }
      } catch (error) {
        enqueueSnackbar(t('errorMsg'), {
          variant: 'error',
        });
      }
    })();
  };

  const onSubmit = () => {
    handleFormSubmit();
  };

  return {
    onSubmit,
    status,
    handleChange,
  };
};
